













































import {
  getServiceTaskDefault,
  ServiceTaskDefault,
  saveServiceTaskDefault
} from "@/api/project/service-task-default-api";
import { Component, Vue } from "vue-property-decorator";
import ErrorAlert from "@/components/ErrorAlert.vue";

@Component({
  components: {
    ErrorAlert
  }
})
export default class ServiceTaskDefaultFormPage extends Vue {
  params: ServiceTaskDefault = {
    id: "",
    name: "",
    value: "",
    code: ""
  };

  errors = [];

  async mounted() {
    const id = this.$route.params.id;
    let res = {} as ServiceTaskDefault;
    if (id) {
      res = ((await getServiceTaskDefault(id)) || {}) as ServiceTaskDefault;
    }

    this.setParams(res);
  }

  setParams(res = {} as ServiceTaskDefault) {
    Object.keys(this.params).forEach(key => {
      this.params[key as keyof ServiceTaskDefault] =
        res[key as keyof ServiceTaskDefault] || "";
    });
  }

  async submit() {
    await saveServiceTaskDefault(this.params)
      .then(() => {
        this.$router.push({ name: "project-task-default" });
      })
      .catch((err: []) => {
        this.errors = err;
      });
  }

  clickSubmitButton() {
    (this.$refs["btnSubmit"] as any).click();
  }
}
